/**
 * CrewSidebar Component
 * Sidebar with crew summary and quick actions
 */

import React from 'react';
import { Plus, Download, Users, Settings, UserPlus } from 'lucide-react';
import CrewSummaryCard from './CrewSummaryCard';

const CrewSidebar = ({
  crewStats,
  onAddCrew,
  onAddFromOrg,  // FT-05: Add from organisation
  onExport,
  onOpenSettings
}) => {
  return (
    <div className="space-y-6">
      {/* Summary Card */}
      <CrewSummaryCard crewStats={crewStats} />

      {/* Quick Actions Card */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-slate-700 px-5 py-3">
          <h3 className="text-base font-semibold text-white flex items-center gap-2">
            <Users className="h-5 w-5 text-white" />
            Quick Actions
          </h3>
        </div>
        <div className="p-6 space-y-2">
          {/* FT-16: min-h-[44px] ensures 44px+ touch targets on mobile */}
          <button
            onClick={onAddCrew}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-white bg-cyan-600 rounded-md hover:bg-cyan-700 min-h-[44px]"
          >
            <Plus className="h-5 w-5 md:h-4 md:w-4" />
            Add Crew Member
          </button>
          {/* FT-05: Add from Organisation button */}
          {/* FT-16: min-h-[44px] ensures 44px+ touch targets on mobile */}
          {onAddFromOrg && (
            <button
              onClick={onAddFromOrg}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-cyan-700 bg-cyan-50 border border-cyan-200 rounded-md hover:bg-cyan-100 min-h-[44px]"
            >
              <UserPlus className="h-5 w-5 md:h-4 md:w-4" />
              Add from Organisation
            </button>
          )}
          <button
            onClick={onExport}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 min-h-[44px]"
          >
            <Download className="h-5 w-5 md:h-4 md:w-4" />
            Export List
          </button>
          <button
            onClick={onOpenSettings}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 min-h-[44px]"
          >
            <Settings className="h-5 w-5 md:h-4 md:w-4" />
            Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrewSidebar;
